import { FAILURE, REQUEST, SUCCESS, action, createRequestTypes } from 'redux-config/reduxHelpers';

const GET_ALL_CONFIGURATION_ITEMS = createRequestTypes('GET_ALL_CONFIGURATION_ITEMS');
const getAllConfigurationItems = {
  request: () => action(GET_ALL_CONFIGURATION_ITEMS[REQUEST]),
  success: data => action(GET_ALL_CONFIGURATION_ITEMS[SUCCESS], { data }),
  failure: error => action(GET_ALL_CONFIGURATION_ITEMS[FAILURE], { error }),
};

export { GET_ALL_CONFIGURATION_ITEMS, getAllConfigurationItems };
